"use client";

import { useLocale } from "next-intl";
import { Logo as BrandLogo } from "@/components/brand/Logo";

export function Logo({ className = "" }: { className?: string }) {
  const locale = useLocale();

  return (
    <a
      id="kessem-header-logo"
      href={`/${locale}`}
      aria-label="Kessem — accueil"
      onClick={(e) => {
        // Force un rechargement complet du site (loader animation rejoué)
        // même si l'utilisateur est déjà sur la home.
        e.preventDefault();
        window.location.assign(`/${locale}`);
      }}
      // `button-like` opts out of the cyan focus-visible halo defined in
      // globals.css (a:focus-visible:not(.button-like)) — that halo
      // appeared as a blue ring around the logo after the loader's
      // programmatic focus restore on some navigations.
      className={`button-like group inline-flex cursor-pointer items-center transition-opacity duration-300 outline-none hover:opacity-80 focus:outline-none focus-visible:outline-none ${className}`}
    >
      <BrandLogo sparkle="sharp" variant="dark" size="md" />
    </a>
  );
}
